import React from 'react';
import {
  GenericComponent,
  GenericComponentType,
  Skeleton,
} from '@sato/components';
import { twMerge } from 'tailwind-merge';

interface Props {
  itemCount?: number;
  className?: string;
  itemClassName?: string;
  /** @default "div" */
  wrapperComponent?: GenericComponentType;
}

export const SkeletonList = ({
  itemCount = 5,
  className,
  itemClassName,
  wrapperComponent = 'div',
}: Props) => (
  <GenericComponent
    className={twMerge('flex w-full flex-col gap-1', className)}
    wrapperComponent={wrapperComponent}
  >
    {[...Array(itemCount).keys()].map((i) => (
      <Skeleton key={i} className={twMerge('h-9 w-full', itemClassName)} />
    ))}
  </GenericComponent>
);
